import {
   Component,
   OnInit, OnDestroy,
   Input, Output,
   ViewChild, ElementRef,
   EventEmitter
} from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { Router } from '@angular/router';

import { SvgIconsModule } from '@library/common/materials';
import { BreadcrumbService, GlobalSearchService, KeyboardShortcutsService } from '@library/core/services';

import { NavItem, NavMenuService } from '../nav-menu.service';
import { first, forkJoin } from 'rxjs';
import { UseraccessService } from '@library/modules/user';

export const TrackItem: NavItem = {
   label: 'Track a Shipment',
   path: '',
   icon: 'track'
};

@Component({
   selector: 'lib-tracking',
   templateUrl: './tracking.component.html',
   styleUrls: ['./tracking.component.scss'],
   animations: [
      trigger( 'slideIn', [
         transition( ':enter', [
            style({ width: 0, 'margin-left': 0 }),
            animate( '300ms ease-in-out', style({ width: '*', 'margin-left': '*' }))
         ]),
         transition( ':leave', [
            animate( '300ms ease-in-out', style({ width: 0, 'margin-left': 0 }))
         ]),
      ]),
   ],
})
export class TrackingComponent implements OnInit, OnDestroy {
   @Input() show = false;
   @Input() showLabel = false;
   @Input() project: string = 'none';


   @Output() active: EventEmitter<boolean> = new EventEmitter();

   @ViewChild('trackInput') trackInput: ElementRef;

   trackItem = TrackItem;

   track_value: string;
   _tracking = false;
   set tracking( value: boolean ) {
      this._tracking = value;
      if ( value ) {
         this.active.emit( true );
         setTimeout( _ => this.trackInput && this.trackInput.nativeElement.focus(), 310 );
      } else {
         this.active.emit( false );
      }
   }
   get tracking() { return this._tracking; }

   public placeholder = 'Enter a HAWB';

   public currentTrack = 'ship';

   public acl: 'both' | 'ship' | 'quote' = 'both';

   constructor(
      public router: Router,
      public breadcrumbs: BreadcrumbService,
      private ks: KeyboardShortcutsService,
      private svgIcons: SvgIconsModule,
      public nav: NavMenuService,
      public globalSearch: GlobalSearchService,
      private access: UseraccessService,
   ) { }

   ngOnInit(): void {
      if ( this.show ) {
         this.ks.register$({
            description: 'Track a Shipment',
            key: 'T',
            keyDisplay: 'Shift + T',
            svgIcon: 'track',
         }).subscribe( _ => this.tracking = true );

         this.ks.escape$.subscribe( _ => {
            this.tracking = false;
            this.track_value = null;
         });
      }

      this.svgIcons.register( 'track' );
      this.svgIcons.register( 'shipments' );
      this.svgIcons.register( 'FCL' );

      if ( this.project === 'customer-portal' ) {
         TrackItem.label = 'Track';
         this.placeholder = 'Enter a HAWB';
      }

      forkJoin([
         this.access.hasAccess('quoting').pipe(first()),
         this.access.hasAccess('tracking').pipe(first()),
      ])
      .subscribe(([ q, b ]) => {
         if ( q && !b ) {
            // no access to booking
            this.placeholder = 'Enter a Quotation';
            this.acl = 'quote';
            this.currentTrack = 'quote';
         } else if ( !q && b ) {
            // no access to quotation
            this.placeholder = 'Enter a HAWB';
            this.acl = 'ship';
            this.currentTrack = 'ship';
         } else {
            this.acl = 'both';
         }
      });
   }

   ngOnDestroy() {
      this.ks.remove( 'T' );
   }

   track(): void {
      if (this.track_value) {
         const value = this.track_value.trim();
         if ( value ) {
            // Check if this is happening on customer portal
            if ( this.project === 'customer-portal' ) {
                  if ( this.currentTrack === 'ship' ) {
                     this.router.navigate([ 'manage', 'shipments', value ]);
                  } else if ( this.currentTrack === 'quote' ) {
                     this.router.navigate([ 'manage', 'quotations', value ]);
                  }  else if ( this.currentTrack === 'container' ) {
                     this.router.navigate([ 'manage', 'shipments', value ]);
                  }

                  this.tracking = false;
                  this.track_value = null;
            } else {
               this.breadcrumbs.newCrumb({ label: 'Tracking > ' + value, path: '/shipments' });
               this.router.navigate([ 'redirect', 'shipments/' + value ], { skipLocationChange: true });
               this.tracking = false;
               this.track_value = null;
            }
         }
      }
   }

   closeTracking():void{
      this.nav.items$.subscribe( items => this.nav.load( items ));
      this.tracking = false;
   }
}
